import * as R from 'ramda'
import {
  FilterPackageElementsBySelection,
  FilterWithProp,
  IsValidCount,
  IsValidPrice,
  WhenHas
} from './pricer.types'

export const isValidCount: IsValidCount = (rules, conf, rulesPerCategories, minPax, maxPax) => ({ adults, children, babies }) => {
  const path: number[] = []

  if (conf.adults.visible) { path.push(adults as number) }

  if (conf.children.visible) { path.push(children as number) }

  if (conf.babies.visible) { path.push(babies as number) }

  if (minPax && minPax === maxPax) {
    const maxPerCategory = rulesPerCategories.map(categoryPossibility => Math.max(...categoryPossibility))
    const result = R.mapObjIndexed((value, key) => {
      const isValueNotOversteppingMax = value <= maxPerCategory[key]
      return (
        parseInt(key) === 0 ? value > 0 && isValueNotOversteppingMax : isValueNotOversteppingMax
      )
    }, path)

    return R.complement(R.contains(false))(R.values(result))
  }

  return R.compose(
    subset => subset.includes(R.last(path)),
    R.when(
      R.complement(R.is(Array)),
      R.pipe(R.keys, R.map(Number))
    ),
    R.defaultTo([]),
    R.path(R.init(path))
  )(rules)
}

const whenHas: WhenHas = (condition, predicate) => R.when(R.always(Boolean(condition)), predicate)
const filterWithProp: FilterWithProp = (prop, value) => R.filter(R.propEq(prop, value))

export const filterPackageElementsBySelection: FilterPackageElementsBySelection = R.curry((
  packageElements, selectedCheckin
) => (
  whenHas(selectedCheckin, filterWithProp('checkin', selectedCheckin))(packageElements))
)

export const isValidPrice: IsValidPrice = price => price !== Number.MAX_VALUE
